
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/halaman-tidak-ditemukan",
      function () {
        return require("private-next-pages/halaman-tidak-ditemukan.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/halaman-tidak-ditemukan"])
      });
    }
  